import moment from "moment";
import { useState } from "react";
import { FaRegTrashAlt } from "react-icons/fa";
import Delete from "../Modals/delete";
import { deleteSmsSubscription } from "../../stores/actions/subscription.actions.types";
import { connect } from "react-redux";
import { formatPhone } from "../../utilities/format-phone";

const SMSSubscriptionTable = ({
  deleteSmsSubscription,
  subscriptions,
  setSubscriptions,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleDelete = async () => {
    setDeleteLoading(true);
    const callback = (data) => {
      if (data.success) {
        setSubscriptions((prevSubscription) =>
          prevSubscription.filter(
            (subscription) => subscription._id !== subscriptionId
          )
        );
        setDeleteLoading(false);
        setIsModalOpen(false);
      } else {
        setDeleteLoading(false);
      }
    };
    let request = {
      id: subscriptionId,
      callback,
    };
    deleteSmsSubscription(request);
  };

  const handleDeleteClick = (id) => {
    setSubscriptionId(id);
    setIsModalOpen(true);
  };

  return (
    <div className='rounded-[10px] bg-white drop-shadow-1 border-l border-slate-300 dark:border-slate-700 dark:bg-boxdark dark:drop-shadow-none border border-stroke bg-white p-4 shadow-1 dark:border-dark-3 dark:bg-gray-dark dark:shadow-card sm:p-3.5 transition-colors duration-300'>
      <div className='max-w-full overflow-y-hidden overflow-x-auto'>
        <table className='w-full table-auto'>
          <thead>
            <tr className='bg-[#F7F9FC] dark:bg-black text-left dark:bg-dark-2 transition-colors duration-300'>
              <th className='min-w-[220px] px-4 py-2 font-medium text-dark dark:text-white xl:pl-7.5'>
                Phone
              </th>
              <th className='min-w-[120px] px-4 py-2 font-medium text-dark dark:text-white'>
                CreatedAt
              </th>
              <th className='min-w-[120px] px-4 py-2 text-right font-medium text-dark dark:text-white xl:pr-7.5'>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {subscriptions?.map((subscription, index) => (
              <tr key={index} className='text-sm'>
                <td
                  className={`border-[#eee] px-4 py-2   dark:border-dark-3 xl:pl-7.5 ${
                    index === subscription.length - 1
                      ? "border-b-0"
                      : "border-b"
                  }`}
                >
                  <h5 className='my-1 text-dark dark:text-white'>
                    {formatPhone(subscription.phone)}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === subscription.length - 1
                      ? "border-b-0"
                      : "border-b"
                  }`}
                >
                  <p className='text-dark dark:text-white'>
                    {moment(subscription.createdAt).format(
                      "D MMM YYYY, hh:mm A"
                    )}
                  </p>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pr-7.5 ${
                    index === subscription.length - 1
                      ? "border-b-0"
                      : "border-b"
                  }`}
                >
                  <div className='flex items-center justify-end'>
                    <div className='group relative'>
                      <button
                        className='mt-[7px] hover:text-primary'
                        onClick={() => handleDeleteClick(subscription._id)}
                      >
                        <FaRegTrashAlt />
                      </button>

                      <span className='absolute left-1/2 top-full w-[50px] -translate-x-1/2 transform rounded  bg-gray-200 px-2 py-1 text-xs text-black opacity-0 transition-opacity  duration-500 group-hover:opacity-100 dark:bg-gray-800 dark:text-white'>
                        Delete
                      </span>
                    </div>

                    {/*Delete Modal */}
                    <Delete
                      opened={isModalOpen}
                      setOpend={setIsModalOpen}
                      title='Subscription Delete'
                      handleDelete={handleDelete}
                      loading={deleteLoading}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });
export default connect(mapStateToProps, {
  deleteSmsSubscription,
})(SMSSubscriptionTable);
